<template>
  <div>
    <e-learning-editor @submit="submit"></e-learning-editor>
  </div>
</template>

<script>
import ELearningEditor from "@/views/health-recommendation/HealthRecommendationEditor";

import axios from "axios";

export default {
  components: {
    ELearningEditor,
  },
  methods: {
    async submit(data) {
      const { posterUrl, title, content, refUrl, targets } = data;

      let loader = this.$loading.show();

      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/health-recommendation`,
          headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
          data: {
            posterUrl,
            title,
            content,
            refUrl,
            targets,
          },
        });

        this.$notify({
          type: "success",
          group: "foo",
          title: "ส่งคำแนะนำสุขภาพแล้ว",
          text: "ผู้ใช้งานจะได้รับข้อความทันที",
        });

        this.$router.replace({
          name: "admin-health-recommendation-index",
        });

        loader.hide();
      } catch (error) {
        loader.hide();

        console.log(error);
      }
    },
  },
};
</script>
